import {inject, Injectable} from '@angular/core';
import {environment} from '../../../../environment';
import {HttpClient} from '@angular/common/http';
import {ProductDetail} from './product-detail.model';

@Injectable({
  providedIn: 'root',
})
export class ProductDetailService {
  private apiProduct = `${environment.wsApiBaseUrl}/api/product`
  protected readonly http = inject(HttpClient);

  findById(id: number, customerAN?: number | string | null) {
    const params: Record<string, string> = {completeSearch: "true"};
    if (customerAN !== undefined && customerAN !== null) {
      params['customerAN'] = String(customerAN);
    }

    return this.http.get<ProductDetail>(`${this.apiProduct}/${id}`, {observe: 'response', params});
  }
}
